import { CONTENT_LOAD, CONTENT_LOAD_SUCCESS, CONTENT_LOAD_ERROR } from './constants'

export function load() {
  return {
    type: CONTENT_LOAD,
  }
}

export function loadSuccess(lastWins) {
  return {
    type: CONTENT_LOAD_SUCCESS,
    lastWins,
  }
}

export function loadError(error) {
  return {
    type: CONTENT_LOAD_ERROR,
    error,
  }
}
